import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import { useDispatch } from "react-redux";
import { saveTags } from "../../Store/slice/tagsSlice";

const CustomSelect = ({ option, handleSelect, categoryId, label, value, showImportant = true }) => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [options, setOptions] = useState(option || []);
  const dispatch = useDispatch();

  useEffect(() => {
    if (option) {
      setOptions(option);
    }
  }, [option]);

  const handleChange = async (selected) => {
    if (handleSelect && typeof handleSelect === "function") {
      handleSelect(selected);
    }
  };

  const handleCreate = async (inputValue) => {
    const newOption = { value: inputValue.toLowerCase(), label: inputValue, categoryId };

    setOptions((prevOptions) => [...prevOptions, newOption]);
    if (handleSelect && typeof handleSelect === "function") {
      let { data } = await axios.post(
        `${configData.config.API_URL}/api/tags/create`,
        { categoryId: newOption.categoryId, name: newOption.value },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      newOption.id = data.tagId;
      handleSelect(newOption);
    }
    fetchAllTags();
  };

  const fetchAllTags = async () => {
    try {
      let { data } = await axios.get(`${configData.config.API_URL}/api/tags`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
      dispatch(saveTags(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {label && (
        <label className="mb-2">
          <p>
            {label} {showImportant && <span>*</span>}
          </p>{" "}
        </label>
      )}
      <CreatableSelect
        theme={(theme) => ({
          ...theme,
          borderRadius: 5,
          colors: {
            ...theme.colors,
            primary50: "#ca373c50",
            primary25: "#ca373c50",
            primary: "#ca373c70",
            danger: "#000000",
            neutral30: "#00000050",
          },
        })}
        isClearable
        value={value}
        options={options}
        onChange={handleChange}
        onCreateOption={handleCreate}
        // isValidNewOption={() => true}
        isValidNewOption={(inputValue, _, selectOptions) =>
          !!inputValue && !selectOptions.some((opt) => opt.label.toLowerCase() === inputValue.toLowerCase())
        }
      />
    </div>
  );
};

export default CustomSelect;
